import { ThemeMode } from '@creditornot/cb-ingredients';
import { createContext, useContext } from 'react';

export const ThemeModeContext = createContext<{ setThemeMode: (themeMode: ThemeMode) => void; themeMode: ThemeMode }>({
  themeMode: 'light',
  setThemeMode: () => {
    console.warn('Calling setThemeMode outside ThemeModeContext does nothing.');
  },
});

export const useThemeMode = () => {
  return useContext(ThemeModeContext);
};
